"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.25 2h13.5A1.25 1.25 0 0 1 16 3.25v9.5A1.25 1.25 0 0 1 14.75 14H1.25A1.25 1.25 0 0 1 0 12.75v-9.5A1.25 1.25 0 0 1 1.25 2Zm-.177 10.927A.25.25 0 0 0 1.25 13H11V3H1.25a.25.25 0 0 0-.25.25v9.5c0 .066.026.13.073.177Zm13.854 0A.25.25 0 0 0 15 12.75v-9.5a.25.25 0 0 0-.25-.25H12v10h2.75a.25.25 0 0 0 .177-.073ZM6.5 5.29l2 2 .71.71-.71.71-2 2-.71-.71 1.5-1.5H3.5v-1h3.79L5.79 6l.71-.71Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.875 3h20.25A1.875 1.875 0 0 1 24 4.875v14.25A1.875 1.875 0 0 1 22.125 21H1.875A1.875 1.875 0 0 1 0 19.125V4.875A1.875 1.875 0 0 1 1.875 3Zm-.53 16.655c.14.141.331.22.53.22h14.813V4.125H1.874a.75.75 0 0 0-.75.75v14.25c0 .199.079.39.22.53Zm21.31 0a.75.75 0 0 0 .22-.53V4.875a.75.75 0 0 0-.75-.75h-4.313v15.75h4.313a.75.75 0 0 0 .53-.22ZM9.75 8.205l3 3 .795.795-.795.795-3 3L8.955 15l2.438-2.437H5.25v-1.125h6.143L8.954 9l.795-.795Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.5 4h27A2.5 2.5 0 0 1 32 6.5v19a2.5 2.5 0 0 1-2.5 2.5h-27A2.5 2.5 0 0 1 0 25.5v-19A2.5 2.5 0 0 1 2.5 4Zm-.707 22.207a1 1 0 0 0 .707.293h19.75v-21H2.5a1 1 0 0 0-1 1v19a1 1 0 0 0 .293.707Zm28.414 0a1 1 0 0 0 .293-.707v-19a1 1 0 0 0-1-1h-5.75v21h5.75a1 1 0 0 0 .707-.293ZM13 10.94l4 4L18.06 16 17 17.06l-4 4L11.94 20l3.25-3.25H7v-1.5h8.19L11.94 12 13 10.94Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 6h40.5A3.75 3.75 0 0 1 48 9.75v28.5A3.75 3.75 0 0 1 44.25 42H3.75A3.75 3.75 0 0 1 0 38.25V9.75A3.75 3.75 0 0 1 3.75 6ZM2.424 39.576c.352.352.829.549 1.326.549h29.813V7.875H3.75A1.875 1.875 0 0 0 1.875 9.75v28.5c0 .497.198.974.55 1.326Zm43.152 0c.352-.352.549-.829.549-1.326V9.75a1.875 1.875 0 0 0-1.875-1.875h-8.813v32.25h8.813c.497 0 .974-.197 1.326-.55ZM19.5 16.672l6 6L26.828 24 25.5 25.327l-6 6L18.172 30l5.063-5.063H10.5v-1.875h12.735L18.172 18l1.328-1.328Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5 8h54a5 5 0 0 1 5 5v38a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V13a5 5 0 0 1 5-5ZM3.232 52.768A2.5 2.5 0 0 0 5 53.5h39.75v-43H5A2.5 2.5 0 0 0 2.5 13v38a2.5 2.5 0 0 0 .732 1.768Zm57.536 0A2.5 2.5 0 0 0 61.5 51V13a2.5 2.5 0 0 0-2.5-2.5H47.25v43H59a2.5 2.5 0 0 0 1.768-.732ZM26 22.23l8 8L35.77 32 34 33.77l-8 8L24.23 40l6.75-6.75H14v-2.5h16.98L24.23 24 26 22.23Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconSidebarCollapseRight = function IconSidebarCollapseRight(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Sidebar Collapse Right' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.warn('Sidebar Collapse Right has been deprecated in favor of Collapse Right. Please update your app.');
  }
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "SidebarCollapseRight"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconSidebarCollapseRight.isDeprecated = true;
IconSidebarCollapseRight.sizes = [16, 24, 32, 48, 64];
IconSidebarCollapseRight.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconSidebarCollapseRight;
exports.default = _default;